/**
 * Per-session configuration returned by `GET /meta/configuration`. Drives the
 * dynamic discount columns and the decimal formatting of the document editor.
 * Refetched when the sales organization (Vkforg) changes.
 */
export interface SalesConfigurationCondition {
  /** The condition (Zu-Abschlag) id — the `conditionId` for the discount column. */
  id: string;
  /** Short code (Begriff). */
  key: string;
  /** Display name (Beschreibung); falls back to `key` when empty. */
  name?: string;
}

export interface SalesConfigurationDecimalDigits {
  /** Decimal places for quantities (Menge). */
  quantity: number;
  /** Decimal places for the unit price *before* tax (Preis pro Stück, netto). */
  price: number;
  /** Decimal places for monetary amounts / values (Werte). */
  amount: number;
  /** Decimal places for weights. */
  weight: number;
}

export interface SalesConfiguration {
  /** Verkaufsrabatte (Kopf/Vkforg) → one editable discount column each. */
  salesDiscounts: SalesConfigurationCondition[];
  /** Einkaufsrabatte (Ekorg) — not used yet (purchase order, later iteration). */
  purchaseDiscounts: SalesConfigurationCondition[];
  decimalDigits: SalesConfigurationDecimalDigits;
}

/** Decimal-digit defaults used until the configuration has loaded. */
export const DEFAULT_SALES_DECIMAL_DIGITS: SalesConfigurationDecimalDigits = {
  quantity: 3,
  price: 2,
  amount: 2,
  weight: 3,
};
